/**
 * Окно «Докупить токены» из плашек нехватки — одна копия на сайт (TopUpHost в App), как окно обрезки фото.
 * Кнопка, открывшая окно, может исчезнуть сразу после оплаты (баланса хватило — плашка ушла, «Пополнить» сменилось на
 * «Посмотреть ответ»), а окно с «Оплата получена» должно остаться до «Готово» (ревью 13.10).
 *
 * Отдельный модуль, а не экспорт из TopUpHost.tsx: файл с компонентом должен экспортировать только компоненты
 * (react-refresh), а CI проверяет изменённые файлы без единого предупреждения.
 */

type Opener = (needTokens: number) => void

let opener: Opener | null = null

/** Хост окна (TopUpHost в App) регистрирует себя при монтировании и снимает при размонтировании. */
export function registerTopUpOpener(fn: Opener | null): void {
	opener = fn
}

/** Открыть докупку; needTokens — сколько не хватает (0 — сумма по умолчанию). Хоста нет (тесты, страница без App) —
 *  false: вызывающий открывает окно у себя. */
export function openTopUp(needTokens: number): boolean {
	if (!opener) return false
	opener(needTokens)
	return true
}
